// DS — postęp (artboard 04/05/11): pasek 4 px i kawałki N z M.
// Bez kręciołka, gdy N/M znane (MAPA decyzja 10). Wypełnienie ma jedno
// przejście szerokości w ds.css (G8-15).

export interface ProgressProps {
  /** 0..1 albo 0..100 (wartości > 1 traktowane jako procent). */
  value: number
  /** Na scenie (ciemne tło): tor --stage-line, wypełnienie --stage-fg. */
  onStage?: boolean
  /** Próg ostrzeżenia (meter gemów): wypełnienie --warn-fg. */
  warn?: boolean
  /** Nazwa dostępna; bez niej pasek jest dekoracją przy widocznej liczbie. */
  label?: string
  className?: string
}

export function Progress({ value, onStage, warn, label, className = '' }: ProgressProps) {
  const pct = Math.max(0, Math.min(100, value > 1 ? value : value * 100))
  return (
    <div
      className={['prog', onStage && 'prog-stage', warn && 'prog-warn', className].filter(Boolean).join(' ')}
      role={label ? 'progressbar' : undefined}
      aria-label={label}
      aria-valuenow={label ? Math.round(pct) : undefined}
      aria-valuemin={label ? 0 : undefined}
      aria-valuemax={label ? 100 : undefined}
      aria-hidden={label ? undefined : true}
    >
      <i style={{ width: `${pct}%` }} />
    </div>
  )
}

export interface ChunksProps {
  total: number
  done: number
  /** Bieżący kawałek (--accent-light). */
  running?: number
  failed?: number
  label?: string
  className?: string
}

/** Kawałki N z M: gotowe --accent, bieżące --accent-light, nieudane --danger-fg. */
export function Chunks({ total, done, running = 0, failed = 0, label, className = '' }: ChunksProps) {
  const n = Math.max(0, total)
  return (
    <div className={['chunks', className].filter(Boolean).join(' ')} role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      {Array.from({ length: n }, (_, i) => {
        const cls = i < done ? 'is-done' : i < done + running ? 'is-running' : i >= n - failed ? 'is-failed' : ''
        return <i key={i} className={cls || undefined} />
      })}
    </div>
  )
}

export default Progress
